import { Badge } from "../../components/ui/Badge";
import type { Campaign } from "../../lib/types";
import { publishStateOf } from "./publishState";

type UnpublishedBadgeProps = {
	campaign: Campaign;
};

export const UnpublishedBadge = ({ campaign }: UnpublishedBadgeProps) => {
	const state = publishStateOf(campaign);
	if (state === "live") return null;

	return (
		<Badge
			variant="alert"
			className="gap-1.5"
			title={
				state === "never"
					? "This offer has never been published, so shoppers cannot see it"
					: "Saved edits are not live yet"
			}
		>
			<span className="h-1.5 w-1.5 rounded-full bg-alert" aria-hidden="true" />
			{state === "never" ? "Not published" : "Unpublished changes"}
		</Badge>
	);
};
